import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { ModalConfirm } from '../../ModalConfirm';

interface IProps {
  isVisible: boolean;
  isSearcherOrSub: boolean;
  onConfirm(): void;
  onCancel(): void;
}

export function ModalRemove({ isVisible, onConfirm, onCancel, isSearcherOrSub }: IProps) {
  return (
    <ModalConfirm
      text={isSearcherOrSub ? 'Точно удалить подборку?' : 'Удалить подборку?'}
      onClose={onCancel}
      isVisible={isVisible}
      footer={
        <>
          <Button theme="fill_white_primary" size="XS" onClick={onCancel}>
            Отменить
          </Button>
          <Button size="XS" onClick={onConfirm}>
            Удалить
          </Button>
        </>
      }
    >
      {isSearcherOrSub ? (
        <p>
          Все, с кем вы поделились, потеряют к ней доступ.
          <br /> Объявления останутся у вас в избранном и в других
          <br /> подборках.
        </p>
      ) : (
        <p>
          Объявления останутся в разделе <br /> “Все объявления” и других подборках
        </p>
      )}
    </ModalConfirm>
  );
}
